import DocTypes from '@/assets/enums/invoicing/DocTypes'

export interface LinkedDocument {
  id: string
  doc_type: string
  reference: string | null
}

export interface DocumentConversion {
  from?: boolean
  to?: boolean
  from_documents?: LinkedDocument[]
  to_documents?: LinkedDocument[]
}

// Documents that can still be converted: the others (an invoice...) only tell where they come from
const CONVERTIBLE_DOC_TYPES: string[] = [
  DocTypes.QUOTE,
  DocTypes.PURCHASE_ORDER,
  DocTypes.INVOICE_PROFORMA
]

/**
 * What the title cell draws around the reference: the document it comes from before it,
 * what it was converted into after it. Nothing is drawn for a link that does not exist.
 */
export function linkedDocumentsVisibility(
  conversion: DocumentConversion | null | undefined,
  docType: string | null | undefined
): { from: boolean; to: boolean } {
  return {
    from: conversion?.from === true,
    to:
      conversion?.to === true &&
      !!docType &&
      CONVERTIBLE_DOC_TYPES.includes(docType)
  }
}
